import PageLayout, { siteTitle } from "@/components/PageLayout";
import SearchBuilder from "@/components/search_builder.js";
import ApplicationPhotoTile from '@/components/inspiration/application_photos/application_photo_tile.js';
import { useState, useReducer, useEffect } from "react";
import Qs from "qs";
import ApplicationPhotoService from '@/lib/services/application_photos';
import searchTranslator from "@/lib/search_translator.js";
import { loadConfig } from "@/lib/utils.js";
import Link from "next/link";
import { cameraIcon } from "@/lib/icons";
import DropdownFilter from "@/components/dropdown_filter";
import { inspirationInflections } from "@/lib/utils.js";
import SearchToggle from "@/components/inspiration/search_toggle";
import Lightbox from "@/components/lightbox";
import { is_mobile } from "@/lib/utils.js";

export default function ApplicationPhotoSearchPage(results){
  const {
    application_photos, 
    page_layout,
    favicon,
    stylesheet,
    cart_enabled,
    initialSearch,
    inspiration_display,
    mobile
  } = results;

  const [isLoading, setIsLoading] = useState(false);
  const [latestPhotos, setLatestPhotos] = useState(application_photos);
  const [lightBoxIndex, setLightBoxIndex] = useState(null);

  const showLightBox = (e, index) => {
    e.stopPropagation();
    setLightBoxIndex(index);
  }
  
  const hideLightBox = () => {
    setLightBoxIndex(null);
    document.body.style.overflow = "visible";
  }

  const getLatestPhotos = (search, pageChange) => {
    setIsLoading((currentIsLoaded) => true);
    fetch(
      "/lex-api/inspiration/application_photos/highlights" +
        "?" +
        Qs.stringify(search, { arrayFormat: "brackets", encode: true })
    )
      .then((res) => res.json())
      .then((data) => {
        setIsLoading((currentIsLoaded) => false);
        setLatestPhotos(data.application_photos);
      });
  };

  return (
    <PageLayout
      title="Inspiration Search"
      page_layout={page_layout}
      cart_enabled={cart_enabled}
      favicon={favicon}
      stylesheet={stylesheet}
    >
      <SearchBuilder
        initialSearch={initialSearch}
        search={getLatestPhotos}
      >
        {(searchState) => {
          let photos = latestPhotos?.slice(0,12)
          return (
            <div className='lexcms-inspiration'>
              <div className='lexcms-inspiration-search-container'>
                <div className="lexcms-inspiration-search-header-text">
                  <h1>Inspirational Search</h1>
                  <p>Discover awe-inspiring images from our projects.</p>
                </div>
                <div className='lexcms-inspiration-sidebar-filters'>
                  { inspiration_display == 'both_application_photos_and_galleries' &&
                    <SearchToggle display={inspiration_display} photosSelected={true} />
                  }
                  <Link href='/lex-cms/inspiration/highlights'>
                    <a className="lexcms-inspiration-view-all-button lexcms-regular-button">
                      <span>Reset All Selections</span>
                    </a>
                  </Link>
                </div>
              </div>
              <div className='lexcms-search-results app-type-photos-container'>
                <div className='lexcms-filters-container lexcms-results-top'>
                  <div className='lexcms-query-container'>
                    <p className='query-text'>Showing {photos?.length} {inspirationInflections('photos', photos?.length)}:</p>
                  </div>
                  <div className='lexcms-inspiration-search-sort-container'>
                    <DropdownFilter
                      searchKey={"q[s]"}
                      className={"inspiration-search-sort-filter"}
                      searchState={searchState}
                      options={[{ value: 'has_hotspot DESC', label: 'Has Hotspot' }]}
                      label="Sort"
                      disableFirst={true}
                    />
                  </div>
                </div>
                <div className='lexcms-result-container'>
                  <div className='app-photo-list'>
                    { photos?.map((d ,i) => {
                      return (
                        <ApplicationPhotoTile app_photo={d} key={d.id} index={i} showLightBox={showLightBox} mobile={mobile} />
                      ); 
                    }) }
                  </div>
                </div>
              </div>
              <Lightbox index={lightBoxIndex} images={photos} hideLightBox={hideLightBox} />
            </div>
          )
        }}
      </SearchBuilder>
    </PageLayout>
  )
}

export async function getServerSideProps(context) {
  let token = context?.req?.headers['lex-api-token'];
  let service = await ApplicationPhotoService.build(
    token,
    context.req?.headers.host
  );
  let q = searchTranslator(context.query);
  let apiFriendlyQ = searchTranslator(context.query, true);
  apiFriendlyQ.q = apiFriendlyQ.q || {}
  apiFriendlyQ.q['s'] = 'created_at desc'
  let search = await service.index(apiFriendlyQ);
  search.initialSearch = q;
  let mobile = is_mobile(context.req?.headers['user-agent']);

  let pageConfig = loadConfig(service);
  return {
    props: { ...search, ...pageConfig, mobile: mobile },
  };
}
